import React, { useState, useEffect } from 'react';
import './Flashcard.css';

const Flashcard = ({ card, onNext, onPrevious, currentIndex, totalCards }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleNext = () => {
    setIsFlipped(false);
    onNext();
  };

  const handlePrevious = () => {
    setIsFlipped(false);
    onPrevious();
  };

  // Reset flip state when card changes
  useEffect(() => {
    setIsFlipped(false);
  }, [card.id]);

  const handleKeyPress = (event) => {
    switch(event.key) {
      case ' ':
      case 'Enter':
        event.preventDefault();
        handleFlip();
        break;
      case 'ArrowRight':
        event.preventDefault();
        handleNext();
        break;
      case 'ArrowLeft':
        event.preventDefault();
        handlePrevious();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [card, isFlipped]);

  return (
    <div className="flashcard-container">
      <div className="flashcard-header">
        <div className="card-counter">
          {currentIndex + 1} of {totalCards}
        </div>
        <div className="card-instructions">
          Click card to flip • Use arrow keys to navigate
        </div>
      </div>

      <div className={`flashcard ${isFlipped ? 'flipped' : ''}`} onClick={handleFlip}>
        <div className="flashcard-inner">
          <div className="flashcard-front">
            <div className="card-content">
              <div className="card-label">Term</div>
              <div className="card-text">{card.term}</div>
            </div>
            <div className="flip-hint">Click to see definition</div>
          </div>
          <div className="flashcard-back">
            <div className="card-content">
              <div className="card-label">Definition</div>
              <div className="card-text">{card.definition}</div>
            </div>
            <div className="flip-hint">Click to see term</div>
          </div>
        </div>
      </div>

      <div className="flashcard-controls">
        <button 
          className="nav-button prev-button" 
          onClick={handlePrevious}
          disabled={currentIndex === 0}
        >
          ← Previous
        </button>
        
        <button className="flip-button" onClick={handleFlip}>
          {isFlipped ? 'Show Term' : 'Show Definition'}
        </button>
        
        <button 
          className="nav-button next-button" 
          onClick={handleNext}
          disabled={currentIndex === totalCards - 1}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default Flashcard;
